'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _chemist = require('chemist');

var _reactI18next = require('react-i18next');

var _FooterCheckoutStyle = require('./FooterCheckoutStyle.scss');

var _FooterCheckoutStyle2 = _interopRequireDefault(_FooterCheckoutStyle);

var _ExternalLink = require('../ExternalLink');

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _localisedPaths = require('../../helpers/localisedPaths');

var _translate = require('../../helpers/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterCheckout = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _reactCssModules2.default)(_FooterCheckoutStyle2.default), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
  (0, _inherits3.default)(FooterCheckout, _React$Component);

  function FooterCheckout() {
    (0, _classCallCheck3.default)(this, FooterCheckout);
    return (0, _possibleConstructorReturn3.default)(this, (FooterCheckout.__proto__ || (0, _getPrototypeOf2.default)(FooterCheckout)).apply(this, arguments));
  }

  (0, _createClass3.default)(FooterCheckout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          code = _props.config.store.code;

      var lng = this.props.params.lng;

      var phone = (0, _translate.contextualTranslation)(t, code, 'flourish.customer_services_telephone');
      var email = (0, _translate.contextualTranslation)(t, code, 'flourish.customer_services_email');

      return _react2.default.createElement(
        'section',
        { styleName: 'm-checkoutInformation', className: 'clearfix' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { styleName: 'a-continueShopping' },
            _react2.default.createElement(_ExternalLink2.default, {
              href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'productsPath', lng),
              text: t('spree.continue_shopping')
            })
          ),
          _react2.default.createElement(
            'article',
            { styleName: 'promotion' },
            _react2.default.createElement(
              'h3',
              { className: 't-title t-h4 t-text--secondary' },
              t('flourish.footer_checkout.title_1')
            ),
            _react2.default.createElement(
              'p',
              { className: 't-text' },
              t('flourish.footer_checkout.text_1')
            ),
            phone !== '' && _react2.default.createElement(
              'a',
              {
                styleName: 'a-helpline',
                className: 't-text t-h4',
                href: 'tel:' + phone
              },
              phone
            ),
            email !== '' && _react2.default.createElement(
              'a',
              {
                styleName: 'a-ccmail',
                className: 't-text t-h4',
                target: '_blank',
                rel: 'noopener noreferrer',
                href: 'mailto:' + email
              },
              email
            )
          )
        )
      );
    }
  }]);
  return FooterCheckout;
}(_react2.default.Component)) || _class) || _class) || _class);
exports.default = FooterCheckout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/FooterPromotions/FooterCheckout.js
// module id = 2284
// module chunks = 0